import { UAParser } from "ua-parser-js";
export default defineNuxtPlugin(() => {
  const parser = new UAParser();
  const userAgent = navigator.userAgent;
  const deviceInfo = parser.setUA(userAgent).getDevice();
  return {
    provide: {
      deviceType: deviceInfo.type || "desktop", // 'mobile', 'tablet', or 'desktop'
    },
  };
});
